"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FieldModels;
(function (FieldModels) {
    var AssetModel = /** @class */ (function () {
        /**
        * Represents Kentico Cloud's asset
        * @constructor
        * @param {string} name - Name of the asset
        * @param {string} type - Type of the asset
        * @param {number} size - Size of the asset
        * @param {string} description - Description of the asset
        * @param {string} url - Url of the asset
        */
        function AssetModel(name, type, size, description, url) {
            this.name = name;
            this.type = type;
            this.size = size;
            this.description = description;
            this.url = url;
        }
        return AssetModel;
    }());
    FieldModels.AssetModel = AssetModel;
    var MultipleChoiceOption = /** @class */ (function () {
        /**
        * Represents Kentico Cloud's multiple choice option
        * @constructor
        * @param {string} name - Name of the option
        * @param {string} codename - Codename of the option
        */
        function MultipleChoiceOption(name, codename) {
            this.name = name;
            this.codename = codename;
        }
        return MultipleChoiceOption;
    }());
    FieldModels.MultipleChoiceOption = MultipleChoiceOption;
    var TaxonomyTerm = /** @class */ (function () {
        /**
       * Represents taxonomy term
       * @constructor
       * @param {string} name - Name of the taxonomy option
       * @param {string} codename - Codename of the option
       */
        function TaxonomyTerm(name, codename) {
            this.name = name;
            this.codename = codename;
        }
        return TaxonomyTerm;
    }());
    FieldModels.TaxonomyTerm = TaxonomyTerm;
})(FieldModels = exports.FieldModels || (exports.FieldModels = {}));
//# sourceMappingURL=field-models.js.map